export default {
      id: "microphone-available-usage",
      viewBox: "0 0 81 111",
      url: __webpack_public_path__ + "img/icons.svg#microphone-available",
      toString: function () {
        return this.url;
      }
    }